export class GuestRegistrationRequestToOTPCreatePatientRequestConverter {
    static create = () => {
        return new GuestRegistrationRequestToOTPCreatePatientRequestConverter();
    };
    toModel = (source) => {
        return {
            address1: source.address1,
            address2: source.address2,
            city: source.city,
            state: source.state,
            zip: source.zip,
            dateOfBirth: source.dateOfBirth,
            email: source.email,
            firstName: source.firstName,
            middleName: source.middleName,
            lastName: source.lastName,
            gender: source.gender,
            phone: source.phone,
            phoneType: source.phoneType,
            guardianRequest: source.guardianRequest || false,
            guardianFirstName: source.guardianFirstName,
            guardianLastName: source.guardianLastName,
            guardianDateOfBirth: source.guardianDateOfBirth,
        };
    };
}
